var map = {
	"./2_5_unit_1.png": "0261",
	"./2_5_unit_2.png": "8443",
	"./5_unit.png": "dbe5",
	"./battery.png": "741b",
	"./bolt.png": "dfd1",
	"./graph-placeholder.png": "38f7",
	"./info-icon-co2.png": "5998",
	"./info-icon-energy.png": "fa91",
	"./info-icon-usage.png": "6cbb",
	"./logo.png": "cf05",
	"./logo_cl.png": "f926",
	"./multi_unit_1.png": "63d0",
	"./status-1.png": "7023",
	"./status-2-glow.png": "34be",
	"./status-2.png": "8106",
	"./status-3-glow.png": "e376",
	"./status-3.png": "47f1",
	"./status.png": "570f",
	"./unit-card-battery.png": "5dab",
	"./unit-card-power.png": "51db",
	"./unit-card-status-charging.png": "b01f",
	"./unit-card-status-discharging.png": "4589",
	"./unit-card-status.png": "4453"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";